import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const CmsIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            d='M13.625 10C13.625 11.0355 12.7855 11.875 11.75 11.875C10.7145 11.875 9.875 11.0355 9.875 10C9.875 8.96447 10.7145 8.125 11.75 8.125C12.7855 8.125 13.625 8.96447 13.625 10Z'
            fill='#C7CAD4'
        />
        <path
            d='M14.2763 14.3158C13.5349 14.7507 12.6716 15 11.75 15C8.98858 15 6.75 12.7614 6.75 10C6.75 7.23858 8.98858 5 11.75 5C12.791 5 13.7577 5.31814 14.5582 5.8625L15.8931 3.74722C14.706 2.95911 13.2816 2.5 11.75 2.5C7.60786 2.5 4.25 5.85786 4.25 10C4.25 14.1421 7.60786 17.5 11.75 17.5C13.1622 17.5 14.4833 17.1097 15.6112 16.4311L14.2763 14.3158Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default CmsIcon
